export default __webpack_public_path__ + "static/media/bannerImage-1.7d4dfd76.jpg";